import styled from '@emotion/styled';
import {
  Accordion,
  ChurchOutlineMediumIcon,
  FlowerBouquetOutlineMediumIcon,
  PetsOutlineMediumIcon,
  Section,
  TextParagraph,
  UnorderedList,
  UrnOutlineMediumIcon,
  token,
} from '@ferreri/prever-component-lib';
import {
  usePetCremation,
  usePlanChapel,
  usePlanCremation,
  usePlanFuneral,
} from './plan-detail.store';

type PlanCoveragesProps = {
  slug: string;
  uf?: string;
};

const PlanCoverages = (props: PlanCoveragesProps) => {
  const morePriorityUf = props.uf;
  const params = { slug: props.slug, uf: morePriorityUf };
  const planFuneral = usePlanFuneral(params);
  const planChapel = usePlanChapel(params);
  const planCremation = usePlanCremation(params);
  const petCremation = usePetCremation(params);

  return (
    <Accordion
      items={convertItems(planFuneral, planChapel, planCremation, petCremation)}
      openItem={0}
    />
  );
};

const convertItems = (planFuneral, planChapel, planCremation, petCremation) =>
  [
    planFuneral && {
      icon: <FlowerBouquetOutlineMediumIcon />,
      title: 'Assistência funeral',
      content: (
        <InsideUnorderedList>
          <UnorderedList items={planFuneral?.items} />
        </InsideUnorderedList>
      ),
    },
    planChapel && {
      icon: <ChurchOutlineMediumIcon />,
      title: planChapel?.title,
      content: (
        <InsideUnorderedList>
          <UnorderedList items={planChapel?.items} />
        </InsideUnorderedList>
      ),
    },
    planCremation && {
      icon: <UrnOutlineMediumIcon />,
      title: planCremation?.title,
      content: <TextParagraph>{planCremation?.description}</TextParagraph>,
    },
    petCremation && {
      icon: <PetsOutlineMediumIcon />,
      title: petCremation?.title,
      content: (
        <Section>
          <TextParagraph>{petCremation?.description}</TextParagraph>
          <InsideUnorderedList>
            <UnorderedList items={petCremation?.items} />
          </InsideUnorderedList>
        </Section>
      ),
    },
  ].filter((item) => Boolean(item));

export const InsideUnorderedList = styled.div`
  padding-left: ${token.spacing.spacingMedium};
`;

export default PlanCoverages;
